import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router/index'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { startRdIconFallback } from './services/rd-icon-fallback'
import { usePermissions } from './composables/usePermissions'
import { useUserStore } from './stores/user-store'

const ensureRandomUuid = () => {
  const cryptoApi = globalThis.crypto
  if (!cryptoApi || typeof cryptoApi.randomUUID === 'function') {
    return
  }

  Object.defineProperty(cryptoApi, 'randomUUID', {
    value: () => {
      const bytes = new Uint8Array(16)
      cryptoApi.getRandomValues(bytes)

      // RFC 4122 version 4 UUID bits.
      bytes[6] = (bytes[6] & 0x0f) | 0x40
      bytes[8] = (bytes[8] & 0x3f) | 0x80

      const toHex = (value: number) => value.toString(16).padStart(2, '0')
      return (
        `${toHex(bytes[0])}${toHex(bytes[1])}${toHex(bytes[2])}${toHex(bytes[3])}-` +
        `${toHex(bytes[4])}${toHex(bytes[5])}-` +
        `${toHex(bytes[6])}${toHex(bytes[7])}-` +
        `${toHex(bytes[8])}${toHex(bytes[9])}-` +
        `${toHex(bytes[10])}${toHex(bytes[11])}${toHex(bytes[12])}${toHex(bytes[13])}${toHex(bytes[14])}${toHex(bytes[15])}`
      )
    },
    configurable: true,
    writable: true,
  })
}

ensureRandomUuid()

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

const applyPermissionVisibility = (el: HTMLElement, value: string[] | string | undefined) => {
  const required = Array.isArray(value) ? value : value ? [value] : []
  const { hasAnyPermission } = usePermissions()
  el.style.display = required.length === 0 || hasAnyPermission(required) ? '' : 'none'
}

app.directive('permission', {
  mounted(el, binding) {
    applyPermissionVisibility(el as HTMLElement, binding.value)
  },
  updated(el, binding) {
    applyPermissionVisibility(el as HTMLElement, binding.value)
  },
})

if (import.meta.env.VITE_APP_GTM_ENABLED && import.meta.env.VITE_APP_GTM_KEY) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
startRdIconFallback()
